<template>
  <div>
    <table-grid
      ref="tableGrid"
      search-table
      @select="selectResource"
      :headers="headers"
      :items="resources"
      :loading="loading"
      :multiple="true"
      :noPagination="true"
      :itemsPerPage="pagination.limit"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @change-page="changePage"
    />
  </div>
</template>

<script>
import resourceService from "@/services/resourceService";
import environmentService from "@/services/environmentService";
export default {
  props: ["value", "alerts"],
  data() {
    return {
      loading: false,
      resourcesSelect: [],
      resources: [],
      environments: [],
      headers: [
        {
          text: this.$t("entities.resource.props.description"),
          align: "left",
          sortable: false,
          value: "description",
        },
        {
          text: this.$t("entities.resource.props.environmentId"),
          align: "left",
          sortable: false,
          value: "environmentDescription",
        },
      ],
      pagination: {
        total: 0,
        limit: 1000,
        page: 1
      }
    };
  },
  watch: {
    async value() {
      await this.getResources();
    },
  },
  computed: {
			lengthPaginationComp() {
				let total = this.pagination.total;
				let round = Math.ceil(total / this.pagination.limit);
				return total < 1 ? 1 : round;
			},
		},
  methods: {
    async changePage(page) {
				this.pagination.page = page;
				window.scrollTo(0, 0);
				await this.getResources();
			},
    selectResource(resources) {
      this.resourcesSelect = resources;
      let ids = [];
      resources.forEach((rt) => ids.push(rt.id));
      this.value.resourceIds = ids;
    },
    updateResourceIds() {
      let resources = [];
      this.value.resourceIds.filter((id) => {
        let resource = this.resources.filter((rt) => rt.id == id)[0];
        if (resource != null) resources.push(resource);
      });

      this.resourceSelect = resources;
      this.$refs.tableGrid.selectRange(resources);
    },
    async getEnvironments() {
      let res = await environmentService.getAll();
      if (res.success) this.environments = res.data.data;
    },
    async getResources() {
      this.loading = true;
      await this.getEnvironments();
      let res = await resourceService.getAll(this.pagination.page, this.pagination.limit);
      this.loading = false;
      if (res.success) {
        this.pagination.total = res.data.total
        res.data.data.forEach((rt) => {
          let environment = this.environments.filter((e) => e.id == rt.environmentId)[0];
          if (environment != null) rt.environmentDescription = environment.description;
        });

        res.data.data.sort((a, b) => {
          if (a.environmentDescription > b.environmentDescription) return 1;
          else if (a.environmentDescription < b.environmentDescription) return -1;
          else return 0;
        });

        this.resources = res.data.data;
        this.updateResourceIds();
      }
    },
  },
  async mounted() {
    if (!this.value.resourceIds) this.value.resourceIds = [];

    await this.getResources();
  },
};
</script>
